


const API_COACH_RATING_REQUEST = 'API_COACH_RATING_REQUEST';
const RESET_CODE_REQUEST = 'RESET_CODE_REQUEST';
const API_COACH_RATING_SUCCESS = 'API_COACH_RATING_SUCCESS';
const API_COACH_RATING_FAILURE = 'API_COACH_RATING_FAILURE';
const SHOW_RATING = 'SHOW_RATING';





export const coachRatingsRequest = payload => ({
  type: API_COACH_RATING_REQUEST,
  payload: payload
});
export const showRatingPopup = payload => ({
  type: SHOW_RATING,
  payload: payload
});

export const coachRatingsSuccess = payload => ({
  type: API_COACH_RATING_SUCCESS,
  payload,
});

export const coachRatingsFailure = payload => ({
  type: API_COACH_RATING_FAILURE,
  payload,
});

export const resetCodeRequest = payload => ({
  type: RESET_CODE_REQUEST,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  message:null,
  showRating:false,
};

export function coachRatingReducer(state = initialState, action) {
 
  switch (action.type) {
    case API_COACH_RATING_REQUEST:
    return {
      ...state,
      fetching: true,
      isFetched: false,
    };
    case SHOW_RATING:
        return {
          ...state,
          showRating: action.payload,
          isFetched: false,
        };
    case RESET_CODE_REQUEST:
    return {
      ...state,
      codeMessage: null
    };
     
    case API_COACH_RATING_SUCCESS:
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        message: action.payload
      };
    case API_COACH_RATING_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/coachRatings.js